import {parseDuration} from 'utils/duration';

// Default wait time between delivery method ranks (5 minutes in ISO 8601 duration format)
export const DEFAULT_WAIT_TIME = 'PT5M';

/**
 * Returns the allowed number of priority levels (containers) based on the wait time ISO string.
 * @param {string} isoDuration - Wait time as ISO 8601 duration string
 * @returns {number} Container limit
 */
export function getContainerLimit(isoDuration) {
  const {hours, minutes} = parseDuration(isoDuration);
  const totalHours = hours + minutes / 60;
  if (totalHours >= 24) return 2;
  if (totalHours >= 16) return 3;
  if (totalHours >= 11) return 4;
  if (totalHours >= 6) return 5;
  return 10;
}
